/* @flow */
import React, { Component } from 'react';
import { Field } from 'redux-form';

import i18n from '../../../../i18n/i18n.js';
import Button from '../../Inputs/Button';

type Props = {
    branding: {
        paywall_buttons_bg_color: String,
        paywall_buttons_text_color: String,
    },
    lng: string,
    backgroundButtonColor: string,
    textButtonColor: string,
    params: {
        anyTouched: boolean,
        syncErrors: Object,
    },
    disabled: boolean,
    handleBack: Function,
};

export default class CardPaymentForm extends Component<Props> {
    render() {
        const {
            branding,
            lng,
            backgroundButtonColor,
            textButtonColor,
            params,
            disabled,
            discountAmount,
            paymentMethod,
            invalidVoucher,
        } = this.props;

        const disablePaypalPay = disabled || (!disabled && invalidVoucher);

        return (
            <div className="price buttonholder">
                <a onClick={this.props.handleBack} href="#" className="back">
                    &lang; {i18n.t('modal_back', { lng })}
                </a>
                {paymentMethod === 'paypal' ? (
                    disablePaypalPay ? (
                        <button
                            style={{
                                border: `solid 1px ${
                                    branding.paywall_buttons_bg_color
                                }`,
                                color: branding.paywall_buttons_bg_color,
                            }}
                            disabled
                        >
                            <span className="buttonlabel">
                                {i18n.t('payment_pay', { lng })}
                            </span>
                        </button>
                    ) : (
                        <button
                            style={{
                                backgroundColor: backgroundButtonColor,
                                color: '#fff',
                                border: `solid 1px ${backgroundButtonColor}`,
                            }}
                        >
                            <span className="buttonlabel">
                                {i18n.t('payment_pay', { lng })}
                            </span>
                        </button>
                    )
                ) : (
                    <Button
                        text={i18n.t('payment_pay', { lng })}
                        backgroundColor={branding.paywall_buttons_bg_color}
                        discountAmount={discountAmount}
                        touched={params && params.anyTouched}
                        errors={params && params.syncErrors}
                        invalidVoucher={invalidVoucher}
                        isFromPayment={true}
                    />
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/ui/components/Forms/Payments/PaymentButtons.js